<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" to="/home">DH</router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#menu">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="menu">
            <ul class="navbar-nav mr-sm-2">
                <li class="nav-item" :class="{active : currentPage.startsWith('/dashboard')}" v-if="user.email">
                    <router-link class="nav-link" to="/dashboard"> Dashboard </router-link>
                </li>
                <li class="nav-item" :class="{active : currentPage.startsWith('/trips')}" v-if="user.email">
                    <router-link class="nav-link" to="/trips/-1">Add trip</router-link>
                </li>
                <li class="nav-item" :class="{active : currentPage.startsWith('/trip-reports')}" v-if="user.email">
                    <router-link class="nav-link" to="/trip-reports">Trip reports</router-link>
                </li>

                <li class="nav-item" :class="{active : currentPage.startsWith('/contact-us')}">
                    <router-link class="nav-link" to="/contact-us">Contact us</router-link>
                </li>
            </ul>
            <form class="mx-auto mr-auto d-inline w-50 mr-auto" >
                <div class="input-group" v-if="user.email">
                    <input class="form-control"
                           @input="onChange"
                           name="searchVal"
                           v-bind:value="trips.searchVal"
                           type="search" placeholder="Search by trip code or waypoint name"/>
                    <span class="input-group-append">
                        <button class="btn btn-outline-success my-2 my-sm-0"
                                v-on:click="submit"
                                type="submit" v-if="!trips.submitting">Search</button>
                    </span>
                </div>
            </form>
            <template v-if="user.email">
                <a href="/api/users/logout">logout</a>
            </template>
            <template v-if="!user.email">
                <router-link to="/login">login</router-link>
            </template>
        </div>

    </nav>
    
</template>

<script>
    import {mapState, mapActions} from "vuex";
    export default {
        name: "app_nav",
        computed: {
            currentPage: function () {
                return this.$route.path;
            },
            ...mapState({
                user: state => state.globalStore.user,
                trips: state => state.trips
            }),
        },
        methods: {
            ...mapActions({
                search: "submitTripSearch",
                searchChange: "tripsChange"
            }),
            onChange(event) {
                this.searchChange({name: event.target.name, value: event.target.value})
            },submit() {
                this.search(() => this.$router.push({path: '/trips'}))
            }
        },
    }
</script>

<style scoped>

</style>
